import { getAxiosInstance } from '../np-rest/rest';
import { snackActions } from '../sc-utilities/SnackBar';

export const fetchOEMPartCount = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async _dispatch => {
        try {
            let countRes = await rest.post("oem-part/count", filterData, { cancelToken: options.countSource.token });
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                }
                return { data: countRes.data.result.data }
            }
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch oem part."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch oem part."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 };
        }
    }
};


export const fetchOEMPart = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async _dispatch => {
        try {
            let listRes = await rest.post("oem-part/list", filterData, { cancelToken: options.listSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                return { data: listRes.data.result.data };
            }
            return { data: [] };
        }
        catch (error) {
            return { data: [] };
        }
    }
};

export const bulkDeleteOEMParts = params => {
    const rest = getAxiosInstance();
    return async _dispatch => {
        try {
            let res = await rest.post('/oem-part/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully deleted oem part.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete oem part."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}
